import { Modal, Skeleton } from 'antd';
import { useDispatch } from 'react-redux';

import styles from './ExportVideo.module.css';
import useExportVideo from '../../hooks/useSubscription/useExportVideo';

import { exportVideoModal } from '../../types';
import { updateExportVideoState } from '../../actions';
import ExportVideoStartError, {
  startExportErrorTypes,
} from './ExportVideoStartError';
import ExportVideoStart from './ExportVideoStart';

const ExportVideoStartModal = () => {
  const dispatch = useDispatch();

  const { startExportVideo, exportState } = useExportVideo();

  const modalType = exportState.modal;

  const handleCancel = () => {
    dispatch(updateExportVideoState({ modal: exportVideoModal.none }));
  };

  const handleExportVideo = async () => {
    startExportVideo();
  };

  const isModalVisible =
    modalType !== undefined && modalType !== exportVideoModal.none;

  const isReadyToExport = modalType === exportVideoModal.start;

  const renderModal = () => {
    switch (modalType) {
      case exportVideoModal.start:
        return <ExportVideoStart />;
      case exportVideoModal.alreadyProcessingError:
        return (
          <ExportVideoStartError
            type={startExportErrorTypes.alreadyProcessing}
          />
        );
      case exportVideoModal.maxLengthExceededError:
        return (
          <ExportVideoStartError type={startExportErrorTypes.lengthExceeded} />
        );
      case exportVideoModal.maxFeedCardsExceededError:
        return (
          <ExportVideoStartError
            type={startExportErrorTypes.feedCardsExceeded}
          />
        );
      case exportVideoModal.loading:
        return (
          <div className={styles.exportVideoModalLoading}>
            <Skeleton active />
          </div>
        );
    }
  };

  return (
    <Modal
      title={'Export to Video'}
      open={isModalVisible}
      centered
      destroyOnClose
      onCancel={handleCancel}
      okText={isReadyToExport ? 'Export my giide' : 'Ok'}
      onOk={() => (isReadyToExport ? handleExportVideo() : handleCancel())}
      cancelText={'Cancel'}
      footer={modalType === exportVideoModal.loading ? null : undefined}
      // footer={
      //   isReadyToExport ? (
      //     <OkFooter />
      //   ) : modalType === exportVideoModal.loading ? null : (
      //     <ErrorFooter />
      //   )
      // }
      className={styles.exportVideoModal}
    >
      {renderModal()}
    </Modal>
  );
};

export default ExportVideoStartModal;
